import React from 'react'
import Signin from './sign-in/Signin'
import './authindex.css'
import { Button } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
// import { Button } from '@material-ui/core'

function AuthIndex(props:any) {
    const history = useHistory()

    const handleChangelick = () => {
        // window.location.href='https://efone.ca/pricing/business'
        history.push('/createaccount')
    }
    return (
        <div className="auth_page_container">
            <div className="auth_left_side">
                <div className="logo_section">
                    <img src="/assets/images/customer-service.png" className='customer-support-icon' alt="" />
                </div>
                <h1>Welcome to EasySupport</h1>
                {/* <h3>Don't have any account</h3>
                <div className="auth_btn">
                    <Button variant="outlined"
                     onClick={handleChangelick}
                     className="auth_btn_styles">Sign up</Button>
                </div> */}
            </div>

            <div className="auth_right_side">
                <Signin />
            </div>
        </div>
    )
}

export default AuthIndex
